import React from "react";
import {
  DefaultButton,
  MessageBar,
  MessageBarType,
  PrimaryButton,
  Separator,
  TextField,
  Spinner,
  SpinnerSize,
} from "@fluentui/react";
import { connect } from "react-redux";
import Person from "./Person";
import Progress from "./Progress";
import PersonalData from "./SiteEditElements/PersonalData";
import SensitivePersonalData from "./SiteEditElements/SensitivePersonalData";
import ExternalCollaboration from "./SiteEditElements/ExternalCollaboration";
import Confidentiality from "./SiteEditElements/Confidentiality";
import ExpirationDay from "./SiteEditElements/ExpirationDay";
import SecuredComponent from "./SiteEditElements/SecuredComponent";
import QuotaChange from "./SiteEditElements/QuotaChange";
import { ModalDialog } from "../formFields/Dialog";
import {
  SiteStatus,
  LocationType,
  SiteType,
} from "../../GlobalConst/globalEnums";
import Api from "../../services/Api";
import DimensionPicker from "./SiteEditElements/DimensionPicker";
import SiteUrl from "./SiteEditElements/SiteUrl";
import { Pivot, PivotItem } from "@fluentui/react";
import SiteTasks from "./SiteTasks";
import ArchivePeriodDropdown from "../CustomComponents/ArchivePeriodDropdown";
import DeleteReason from "../CustomComponents/DeleteReason";

class SiteEditor extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      site: null,
      updateSet: [],
      updatedOwners: [],
      approver: null,
      editable: false,
      onPremise: false,
      myOwnSite: false,
      messageVisible: false,
      error: false,
      isLoading: false,
      isMsTeams: false,
      isGroup: false,
      isGroupConnected: false,
      geography: null,
      management: null,
      isSaving: false,
      updatedProjectManager: [],
      updatedSponsor: [],
      updatedSteeringCommittee: [],
      isIATU: false,
      isProjectManagerChanged: false,
      isSponsorChanged: false,
      isSteeringCommitteeChanged: false,
      isChildrenUpdateValid: true,
      childrenValidation: {},
      isPWA: false,
      businessJustification: "",
      warning: false,
      choosenPeriod: "1",
      isLongTermConfirmed: false,
    };
  }

  onWriteEvent(event, value) {
    if (value.length > 0) {
      this.setState({ warning: false });
    }
    this.setState({ businessJustification: value });
  }

  componentDidMount() {
    this._isMounted = true;
    this.getSite(this.props.siteId);
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  setSiteType(site) {
    this.setState({
      isMsTeams: site.siteTemplate.siteType === SiteType.team,
      isGroup: site.siteTemplate.siteType === SiteType.group,
      isGroupConnected: site.isGroupConnected,
    });

    return site.isGroupConnected;
  }

  updateChangeWithCustomAction(key, value) {
    this.updateChange(key, value, () => this.customUpdateActions(key, value));
  }

  updateChange(key, value, callBack) {
    console.log(key);
    console.log(value);
    let set = this.state.updateSet;
    set = set.filter((x) => x.key !== key);
    if (this.state.site[key] === value || value === null) {
      this.setState({ updateSet: set }, callBack);
      return;
    }
    let myChange = { key: key, value: value };
    set.push(myChange);
    this.setState({ updateSet: set }, callBack);
    console.log(set);
  }

  updateChildrenValidation = (key, isValid) => {
    const childrenValidation = {
      ...this.state.childrenValidation,
      [key]: isValid,
    };
    const isChildrenUpdateValid = Object.keys(childrenValidation).reduce(
      (value, key) => {
        return value && childrenValidation[key];
      },
      true,
    );

    this.setState({
      isChildrenUpdateValid,
      childrenValidation,
    });
  };

  updateChangeDimension(key, value, callBack) {
    let set = this.state.updateSet;
    set = set.filter((x) => x.key !== key);
    if (
      value != null &&
      this.state.site.dimension &&
      this.state.site.dimension[key] &&
      this.state.site.dimension[key].code === value.key
    ) {
      this.setState({ updateSet: set }, callBack);
      return;
    }
    let myChange = { key: key, value: value };
    set.push(myChange);
    this.setState({ updateSet: set }, callBack);
  }

  customUpdateActions(key, value) {
    if (key === "sensitiveGdpr" && value === true) {
      this.updateChange("gdpr", true);
    }

    if (key === "gdpr" && value === false) {
      this.updateChange("sensitiveGdpr", false);
    }
  }

  getUpdatedValue(key, defaultSet) {
    const set = this.state.updateSet;
    const result = set.filter((x) => x.key === key);
    if (result.length === 0) {
      return defaultSet != null ? defaultSet[key] : null;
    } else {
      return result[0].value;
    }
  }

  editable() {
    this.setState({ editable: true });
  }

  pickGeoItem(hit) {
    this.setState({ geography: hit });
    this.updateChangeDimension("geography", hit);
  }

  pickManItem(hit) {
    this.setState({ management: hit });
    this.updateChangeDimension("management", hit);
  }

  setNewOwner(owner) {
    this.setState({ updatedOwners: owner });
    if (owner && owner.length === 1) {
      this.getApprover(owner[0].id);
    } else {
      this.setState({ approver: this.state.approver });
    }
  }

  setNewProjectManager(projectManager) {
    this.setState({ isProjectManagerChanged: true });
    this.setState({ updatedProjectManager: projectManager });
  }

  setNewSponsor(sponsor) {
    this.setState({ isSponsorChanged: true });
    this.setState({ updatedSponsor: sponsor });
  }

  setNewSteeringCommittee(steeringCommittee) {
    this.setState({ isSteeringCommitteeChanged: true });
    this.setState({ updatedSteeringCommittee: steeringCommittee });
  }

  isRequestBlocked() {
    return (
      this.state.onPremise &&
      this.state.updatedOwners.length > 0 &&
      !this.state.approver &&
      !this.state.isLoading
    );
  }

  getSite(siteId) {
    this.setState({ isLoading: true });

    Api.get(`/Site?id=${siteId}`)
      .then((res) => res.data)
      .then((site) => {
        const isGroupConnected = this.setSiteType(site);
        if (this._isMounted) {
          this.setState({
            site,
            isLoading: false,
            onPremise:
              site.farmLocation.locationType === LocationType.onPremise,
            myOwnSite: this.isMySite(site.owners),
            geography: site.dimension ? site.dimension.geography : null,
            management: site.dimension ? site.dimension.management : null,
            isIATU: site.siteIATU ? true : false,
            isIAPCP: site.siteIAPCP ? true : false,
            isPWA: site.siteTemplate.spTemplateName === "PWA#0" ? true : false,
          });

          if (site.owners) {
            this.getApprover(this.props.currentUser.id);
          }
        }
      });
  }

  isMySite(owners) {
    return owners.filter((x) => x.userId === this.props.userId).length !== 0;
  }

  getApprover(userId) {
    this.setState({ isLoading: true });

    Api.get(`/User/Manager?userId=${userId}`)
      .then((res) => res.data)
      .then((user) => {
        if (this._isMounted) {
          this.setState({ approver: user, isLoading: false });
        }
      });
  }

  eraseSelection() {
    let update = this.buildUpdate();
    update.dimension = {
      geography: update.geography
        ? update.geography
        : this.state.site.dimension
        ? this.state.site.dimension.geography
        : null,
      management: update.management
        ? update.management
        : this.state.site.dimension
        ? this.state.site.dimension.management
        : null,
    };
    if (update.extension) {
      update.expirationDate = new Date(
        new Date().setFullYear(new Date().getFullYear() + update.extension),
      ).toISOString();
    }
    this.setState({
      site: { ...this.state.site, ...update },
      updateSet: [],
      updatedOwners: [],
      editable: false,
      error: false,
    });
  }

  buildUpdate() {
    let command = {
      id: this.props.siteId,
    };
    const updateSet = this.state.updateSet;
    updateSet.map((x) => (command[x.key] = x.value));
    if (this.state.updatedOwners.length) {
      command.owners = this.state.updatedOwners.map((x) => ({
        ...x,
        id: x.userId ? x.userId : x.id,
      }));
    }
    if (this.state.updatedOwners.length) {
      command.approver = this.state.approver;
    }

    if (this.state.isProjectManagerChanged) {
      command.projectManager = this.state.updatedProjectManager.map((x) => ({
        ...x,
        id: x.userId ? x.userId : x.id,
      }));
    }

    if (this.state.isSponsorChanged) {
      command.sponsor = this.state.updatedSponsor.map((x) => ({
        ...x,
        id: x.userId ? x.userId : x.id,
      }));
    }

    if (this.state.isSteeringCommitteeChanged) {
      command.steeringCommittee = this.state.updatedSteeringCommittee.map(
        (x) => ({ ...x, id: x.userId ? x.userId : x.id }),
      );
    }
    if (this.state.updateSet.find((x) => x["key"] === "quotaId")) {
      command.changeQuotaComment = this.state.businessJustification;
      command.approver = this.state.approver;
    }

    return command;
  }

  updateSite() {
    if (
      this.state.businessJustification.length === 0 &&
      this.state.updateSet.find((x) => x["key"] === "quotaId")
    ) {
      this.setState({ warning: true });
      return;
    }

    let address = this.state.isGroupConnected
      ? "/UpdateTeamsRequest"
      : "/UpdateSiteRequest";

    if (this.isRequestBlocked()) return;

    this.setState({
      error: false,
      messageVisible: false,
      isLoading: true,
      isSaving: true,
    });
    let update = this.buildUpdate();

    this.eraseSelection();

    Api.post(address, update)
      .then((res) => res.data)
      .then((post) => {
        this.setState({ isLoading: false, isSaving: false });
        if (post === 200) {
          this.setState({ isProjectManagerChanged: false });
          this.setState({ isSponsorChanged: false });
          this.setState({ isSteeringCommitteeChanged: false });
          this.setState({ messageVisible: true });
          if (this.props.callBack) this.props.callBack(this.props.siteId);
        } else {
          this.setState({ error: true });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  saveEnable() {
    return (
      !this.state.isLoading &&
      (this.state.updateSet.length !== 0 ||
        this.state.updatedOwners.length !== 0 ||
        ((this.state.isIATU || this.state.isIAPCP) &&
          this.state.isProjectManagerChanged) ||
        ((this.state.isIATU || this.state.isIAPCP) &&
          this.state.isSponsorChanged) ||
        ((this.state.isIATU || this.state.isIAPCP) &&
          this.state.isSteeringCommitteeChanged)) &&
      this.state.management &&
      this.state.geography &&
      (this.state.site.owners.length > 0 ||
        this.state.updatedOwners.length > 0) &&
      !this.isRequestBlocked() &&
      !this.state.isSaving &&
      (new Date(this.state.site.expirationDate) > Date.now() ||
        this.getUpdatedValue("extension")) &&
      this.state.isChildrenUpdateValid
    );
  }

  editEnabled() {
    return (
      !this.state.isSaving &&
      !this.state.messageVisible &&
      !this.state.editable &&
      this.state.site.siteStatus !== SiteStatus.deleted &&
      this.state.site.siteStatus !== SiteStatus.disabled &&
      this.state.site.url
    );
  }

  deleteSite = (doDelete, reason = null, isApprovalRequest = false) => {
    this.setState({
      error: false,
      messageVisible: false,
      isSaving: true,
      warning: false,
    });
    const post = {
      id: this.props.siteId,
      ...(isApprovalRequest ? {} : { deleteSite: doDelete }),
    };

    if (this.state.site.siteTemplate.id === 6 && reason !== null) {
      post.deleteReasonComment = reason;
      post.isGroupApprovalRequest = true;
    }

    if (this.state.approver) {
      post.approver = this.state.approver;
    }
    this.eraseSelection();

    Api.post("/UpdateSiteRequest", post)
      .then((res) => res.data)
      .then((postRes) => {
        if (postRes === 200) {
          this.setState({ messageVisible: true });
          if (this.props.callBack) this.props.callBack(this.props.siteId);
        } else {
          this.setState({ error: true });
          console.log("Update failed", postRes);
        }
      })
      .catch((error) => {
        if (this._isMounted) {
          this.setState({ error: true, isSaving: false });
          console.log("Error during update request:", error);
        }
      });
  };

  archiveSite = (
    doArchive,
    choosenPeriod,
    longTermArchiveConfirmed,
    templateIdFromProps,
  ) => {
    this.setState({ error: false, messageVisible: false, isSaving: true });

    const siteTemplateId = this.state.site.siteTemplate
      ? this.state.site.siteTemplate.id
      : null;

    if (siteTemplateId === undefined || siteTemplateId === null) {
      console.error(
        "Archivization error: Template ID (templateIdFromProps) has not been delivered.",
      );
      this.setState({ error: true, isSaving: false });
      return;
    }

    const post = {
      id: this.props.siteId,
      archiveSite: doArchive,
      archivePeriod: siteTemplateId === 6 ? 20 : choosenPeriod,
      longArchiveConfirmed: longTermArchiveConfirmed,
    };

    this.eraseSelection();

    Api.post("/UpdateSiteRequest", post)
      .then((res) => res.data)
      .then((post) => {
        if (post === 200) {
          this.setState({ messageVisible: true, isSaving: false });
          if (this.props.callBack) this.props.callBack(this.props.siteId);
        } else {
          this.setState({ error: true });
          console.log("Update failed");
        }
      })
      .catch((error) => {
        this.setState({ error: true, isSaving: false });
        console.log(error);
      });
  };

  displayButton = () => {
    if (
      this.state.choosenPeriod === "1" ||
      this.state.choosenPeriod === "2" ||
      ((this.state.choosenPeriod === "5" ||
        this.state.choosenPeriod === "10") &&
        this.state.isLongTermConfirmed)
    ) {
      return true;
    }
    return false;
  };

  handleCheckBox = (value) => {
    this.setState({ isLongTermConfirmed: value });
    console.log("checkbox", value);
  };

  handlePeriodDropDown = (value) => {
    this.setState({ choosenPeriod: value });
    if (value === "1" || value === "2") {
      this.setState({ isLongTermConfirmed: false });
    }
    console.log("dropdown", value);
  };

  render() {
    if (!this.state.site) {
      return <Spinner size={SpinnerSize.large} label="Loading site data..." />;
    }

    const siteTemplateId = this.state.site.siteTemplate
      ? this.state.site.siteTemplate.id
      : null;

    const disabled = !this.state.editable;

    const projectManager =
      this.state.isIATU || this.state.isIAPCP ? (
        <Person
          limited={true}
          userType="Project Manager"
          updateType="projectManager"
          onChange={this.setNewProjectManager.bind(this)}
          disabled={disabled}
          user={
            this.state.isIATU && this.state.site.siteIATU.projectManager
              ? this.state.site.siteIATU.projectManager
              : this.state.isIAPCP && this.state.site.siteIAPCP.projectManager
              ? this.state.site.siteIAPCP.projectManager
              : null
          }
          isRequired={true}
        />
      ) : (
        <div></div>
      );

    const sponsor =
      this.state.isIATU || this.state.isIAPCP ? (
        <Person
          limited={!this.state.isIAPCP}
          userType="Sponsor"
          updateType="sponsor"
          onChange={this.setNewSponsor.bind(this)}
          disabled={disabled}
          user={
            this.state.isIATU && this.state.site.siteIATU.sponsor
              ? this.state.site.siteIATU.sponsor
              : this.state.isIAPCP && this.state.site.siteIAPCP.sponsor
              ? this.state.site.siteIAPCP.sponsor
              : null
          }
          isRequired={false}
        />
      ) : (
        <div></div>
      );

    const steeringCommitee =
      this.state.isIATU || this.state.isIAPCP ? (
        <Person
          limited={false}
          userType="Steering Committee"
          updateType="steeringCommittee"
          onChange={this.setNewSteeringCommittee.bind(this)}
          disabled={disabled}
          user={
            this.state.site.siteIATU &&
            this.state.site.siteIATU.steeringCommittee
              ? this.state.site.siteIATU.steeringCommittee
              : this.state.site.siteIAPCP &&
                this.state.site.siteIAPCP.steeringCommittee
              ? this.state.site.siteIAPCP.steeringCommittee
              : null
          }
          isRequired={false}
        />
      ) : (
        <div></div>
      );

    const siteTitle = this.state.site && (
      <div className="site-editor-header">
        <div className="site-editor-title" title={this.state.site.title}>
          {this.state.site.title.length > 53
            ? `${this.state.site.title.substr(0, 50)}...`
            : this.state.site.title}
        </div>
        <div className="site-editor-close" onClick={this.props.onRequestClose}>
          X
        </div>
      </div>
    );

    const editor = this.state.site && (
      <div className="site-editor">
        <div style={{ padding: "20px 20px 20px 20px" }}>
          <div>
            <div style={{ width: "100%", height: "40px" }}>
              {this.state.site.url ? (
                <SecuredComponent
                  readSecurityLevel="Reader"
                  editSecurityLevel="Owner"
                  readOnlyAccess={this.state.myOwnSite}
                >
                  <SiteUrl
                    url={this.state.site.url}
                    disabled={disabled || this.state.isPWA}
                    onChange={this.updateChange.bind(this)}
                    onValidation={this.updateChildrenValidation}
                    isOnPremise={this.state.onPremise}
                  />
                </SecuredComponent>
              ) : (
                <TextField
                  autoComplete="off"
                  type="text"
                  disabled={true}
                  defaultValue={`${this.state.site.farmLocation.address}/${
                    this.state.isGroupConnected ? "teams" : "sites"
                  }/${this.state.site.name}`}
                />
              )}
            </div>
            <div>
              <div
                style={
                  this.state.isGroupConnected
                    ? teamsOwnerStyle
                    : sitesOwnerStyle
                }
              >
                <SecuredComponent
                  readSecurityLevel="Reader"
                  editSecurityLevel="Contributor"
                  unlimitedAccess={this.state.myOwnSite}
                >
                  <Person
                    limited={false}
                    userType="Owner"
                    updateType="owner"
                    onChange={this.setNewOwner.bind(this)}
                    disabled={disabled}
                    user={
                      this.state.updatedOwners.length
                        ? this.state.updatedOwners
                        : this.state.site.owners
                    }
                    isRequired={true}
                  />
                  {projectManager}
                  {sponsor}
                  {steeringCommitee}
                </SecuredComponent>
              </div>
              <div
                style={
                  this.state.isGroupConnected
                    ? teamsOwnerStyle
                    : sitesOwnerStyle
                }
              >
                <SecuredComponent
                  readSecurityLevel="Reader"
                  editSecurityLevel="Contributor"
                  unlimitedAccess={this.state.myOwnSite}
                >
                  <Person
                    updateType="siteApprover"
                    disabled={true}
                    userType="Approver"
                    user={this.state.approver}
                  />
                </SecuredComponent>
              </div>
            </div>
            <div
              style={{
                width: "43%",
                marginRight: "42px",
                float: "left",
                clear: "both",
              }}
            >
              <div style={{ marginTop: "10px", position: "relative" }}>
                <SecuredComponent
                  readSecurityLevel="Reader"
                  editSecurityLevel="Contributor"
                  unlimitedAccess={this.state.myOwnSite}
                >
                  <DimensionPicker
                    itemSelector={this.pickGeoItem.bind(this)}
                    searchTitle="Site Audience"
                    searchDataUrl="/Geography"
                    isDisabled={disabled}
                    selection={this.getUpdatedValue(
                      "geography",
                      this.state.site.dimension,
                    )}
                    isRequired={true}
                    treeDataUrl="/Geography"
                    dimensionConfig={
                      (this.state.site.siteTemplate.config || {})
                        .geographyConfig || {}
                    }
                    additionalOptions={[
                      { key: "Cross", value: "Cross Organisation" },
                    ]}
                  />
                </SecuredComponent>
              </div>
              <div style={{ marginTop: "10px", position: "relative" }}>
                <SecuredComponent
                  readSecurityLevel="Reader"
                  editSecurityLevel="Contributor"
                  unlimitedAccess={this.state.myOwnSite}
                >
                  <DimensionPicker
                    itemSelector={this.pickManItem.bind(this)}
                    searchTitle="Management"
                    searchDataUrl="/Management"
                    isDisabled={disabled}
                    selection={this.getUpdatedValue(
                      "management",
                      this.state.site.dimension,
                    )}
                    isRequired={true}
                    treeDataUrl="/Management"
                    dimensionConfig={
                      (this.state.site.siteTemplate.config || {})
                        .managementConfig || {}
                    }
                  />
                </SecuredComponent>
              </div>
            </div>
            <div
              style={
                this.state.isGroupConnected ? quotaAreaTeams : quotaAreaSites
              }
            >
              Quota used:
              <Progress
                usage={this.state.site.quotaUsage / 1024}
                quota={this.state.site.quotaValue.quotaSize}
              />
              <SecuredComponent
                readSecurityLevel="Reader"
                editSecurityLevel="Contributor"
                unlimitedAccess={this.state.myOwnSite}
              >
                <QuotaChange
                  onUpdate={this.updateChange.bind(this)}
                  disabled={disabled}
                  quota={this.state.site.quotaValue}
                  user={this.props.currentUser}
                />
                {this.state.updateSet.find((x) => x["key"] === "quotaId") !==
                undefined ? (
                  <TextField
                    label="Business justification"
                    multiline
                    resizable={false}
                    errorMessage={
                      this.state.warning ? "Comment required" : null
                    }
                    onChange={this.onWriteEvent.bind(this)}
                  />
                ) : (
                  <p></p>
                )}
              </SecuredComponent>
            </div>
            <div style={{ paddingTop: "20px", clear: "both" }}>
              <SecuredComponent readSecurityLevel="Reader">
                <div style={{ paddingBottom: "10px" }}>
                  <span>
                    Site Template: {this.state.site.siteTemplate.name}
                  </span>
                </div>
              </SecuredComponent>
              {!this.state.site.isRdArchive && 
              <SecuredComponent
                readSecurityLevel="Reader"
                editSecurityLevel="Contributor"
                unlimitedAccess={this.state.myOwnSite}
              >
                <ExpirationDay
                  onUpdate={this.updateChange.bind(this)}
                  disabled={disabled}
                  extension={this.getUpdatedValue("extension")}
                  expirationDate={this.state.site.expirationDate}
                  siteStatus={this.state.site.siteStatus}
                />
              </SecuredComponent>
            }
            </div>
            <div >
              General Data Processing Regulations:
            </div>
            <SecuredComponent
              readSecurityLevel="Reader"
              editSecurityLevel="Contributor"
              unlimitedAccess={this.state.myOwnSite}
            >
              <PersonalData
                onUpdate={this.updateChangeWithCustomAction.bind(this)}
                disabled={disabled}
                gdpr={this.getUpdatedValue("gdpr", this.state.site)}
              />
            </SecuredComponent>
            <SecuredComponent
              readSecurityLevel="Reader"
              editSecurityLevel="Contributor"
              unlimitedAccess={this.state.myOwnSite}
            >
              <SensitivePersonalData
                onUpdate={this.updateChangeWithCustomAction.bind(this)}
                disabled={
                  disabled || !this.getUpdatedValue("gdpr", this.state.site)
                }
                sensitiveGdpr={this.getUpdatedValue(
                  "sensitiveGdpr",
                  this.state.site,
                )}
              />
            </SecuredComponent>
            {!this.state.onPremise && (
              <div style={{ marginTop: "40px" }}>
                <SecuredComponent
                  readSecurityLevel="Reader"
                  editSecurityLevel="Contributor"
                  unlimitedAccess={this.state.myOwnSite}
                >
                  <ExternalCollaboration
                    onUpdate={this.updateChange.bind(this)}
                    disabled={disabled || this.state.isMsTeams}
                    externalCollaboration={
                      this.state.site.externalCollaboration
                    }
                  />
                </SecuredComponent>
                {this.state.isMsTeams && (
                  <div className="infoMessage">
                    External sharing is enabled on every MS Team
                  </div>
                )}
              </div>
            )}
            <div>
              <div style={{ marginTop: "40px" }}>
                <SecuredComponent
                  readSecurityLevel="Reader"
                  editSecurityLevel="Contributor"
                  unlimitedAccess={this.state.myOwnSite}
                >
                  <Confidentiality
                    onUpdate={this.updateChange.bind(this)}
                    disabled={disabled}
                    level={this.state.site.confidentiality}
                  />
                </SecuredComponent>
              </div>
            </div>
            <div>
              <SecuredComponent
                readSecurityLevel="Administrator"
                editSecurityLevel="Administrator"
                unlimitedAccess={this.state.myOwnSite}
              >
                <div
                  style={{
                    marginTop: "20px",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <div>
                    {this.editEnabled() && (
                      <DefaultButton
                        className="edit-icon"
                        onClick={this.editable.bind(this)}
                      >
                        {" "}
                        Edit{" "}
                      </DefaultButton>
                    )}
                    {this.saveEnable() && (
                      <PrimaryButton
                        className="edit-icon"
                        onClick={this.updateSite.bind(this)}
                      >
                        {" "}
                        Make change request{" "}
                      </PrimaryButton>
                    )}
                  </div>
                  {this.state.site.url &&
                    !this.state.isGroup &&
                    (this.state.site.siteStatus === SiteStatus.disabled ||
                    this.state.site.siteStatus === SiteStatus.deleted ? (
                      <SecuredComponent
                        readSecurityLevel="Administrator"
                        editSecurityLevel="Administrator"
                        unlimitedAccess={this.state.myOwnSite}
                      >
                        <div
                          title={
                            this.state.site.deletedOutside
                              ? "Site/Teams has been restore"
                              : ""
                          }
                        >
                          <DefaultButton
                            className="edit-icon"
                            disabled={this.state.site.deletedOutside}
                            onClick={() => this.deleteSite(false)}
                          >
                            {this.state.isMsTeams &&
                            this.state.site.SiteStatus !==
                              SiteStatus.pernamently_deleted
                              ? "Restore Team"
                              : "Restore Site"}
                          </DefaultButton>
                        </div>
                      </SecuredComponent>
                    ) : (
                      <div>
                        {this.state.site.url &&
                        !this.state.site.isGroup &&
                        this.state.site.siteStatus === SiteStatus.archived ? (
                          <div style={{ display: "flex", columnGap: "5px" }}>
                            <DefaultButton
                              className="edit-icon"
                              onClick={() => this.archiveSite(false, "", false)}
                            >
                              {this.state.isMsTeams
                                ? "Unarchive Team"
                                : "Unarchive Site"}
                            </DefaultButton>
                            <SecuredComponent
                              readSecurityLevel="Administrator"
                              editSecurityLevel="Administrator"
                            >
                              <ModalDialog
                                title={"Delete Site"}
                                text={
                                  this.state.site.siteTemplate.id === 6 ? (
                                    <DeleteReason
                                      onSend={(reason) => {
                                        this.deleteSite(false, reason, true);
                                        this.setState({
                                          showDeleteReasonForm: false,
                                        });
                                      }}
                                    />
                                  ) : (
                                    <div>
                                      You are going to delete this{" "}
                                      {this.state.isMsTeams ? "team" : "site"}.
                                      It will be deleted permanently. Are you
                                      sure you want to delete this{" "}
                                      {this.state.isMsTeams ? "team" : "site"}?
                                    </div>
                                  )
                                }
                                displayConfirmButton={
                                  this.state.site.siteTemplate.id !== 6
                                }
                                buttonName={`Delete ${
                                  this.state.isMsTeams ? "Team" : "Site"
                                }`}
                                actionConfirmed={() => {
                                  if (this.state.site.siteTemplate.id === 6) {
                                    this.setState({
                                      showDeleteReasonForm: true,
                                    });
                                  } else {
                                    this.deleteSite(true);
                                  }
                                }}
                              />
                            </SecuredComponent>
                            {this.state.site.siteTemplate.id !== 6 && (
                              <ModalDialog
                                title={"Extend Archive"}
                                text={
                                  this.state.isMsTeams
                                    ? "You are going to extend archive for this team. Expiration date will be extended by the period of your choice. Are you sure you want to continue?"
                                    : "You are going to extend archive for this site. Expiration date will be extended by the period of your choice. Are you sure you want to continue?"
                                }
                                buttonName={"Extend Archive"}
                                displayConfirmButton={this.displayButton()}
                                actionConfirmed={() => {
                                  this.archiveSite(
                                    true,
                                    this.state.choosenPeriod,
                                    this.state.isLongTermConfirmed,
                                    siteTemplateId,
                                  );
                                }}
                              >
                                <ArchivePeriodDropdown
                                  onChangeDropDown={this.handlePeriodDropDown}
                                  onChangeCheckBox={this.handleCheckBox}
                                />
                              </ModalDialog>
                            )}
                          </div>
                        ) : (
                          <div style={{ display: "flex", columnGap: "5px" }}>
                            {this.state.isMsTeams ? (
                              <ModalDialog
                                title={"Archive Team"}
                                text={
                                  "You are going to archive this team. It will be set to read-only mode. Are you sure you want to continue?"
                                }
                                buttonName={"Archive Team"}
                                displayConfirmButton={this.displayButton()}
                                actionConfirmed={() => {
                                  this.archiveSite(
                                    true,
                                    this.state.choosenPeriod,
                                    this.state.isLongTermConfirmed,
                                    siteTemplateId,
                                  );
                                }}
                              >
                                {siteTemplateId !== null &&
                                  siteTemplateId !== 6 && (
                                    <ArchivePeriodDropdown
                                      choosenPeriod={this.state.choosenPeriod}
                                      onChangeDropDown={
                                        this.handlePeriodDropDown
                                      }
                                      onChangeCheckBox={this.handleCheckBox}
                                      isLongTermConfirmed={
                                        this.state.isLongTermConfirmed
                                      }
                                    />
                                  )}
                              </ModalDialog>
                            ) : (
                              <ModalDialog
                                title={"Archive Site"}
                                text={
                                  "You are going to archive this site. It will be set to read-only mode. Are you sure you want to archive this site?"
                                }
                                buttonName={"Archive Site"}
                                displayConfirmButton={this.displayButton()}
                                actionConfirmed={() => {
                                  this.archiveSite(
                                    true,
                                    this.state.choosenPeriod,
                                    this.state.isLongTermConfirmed,
                                    ArchivePeriodDropdown,
                                  );
                                }}
                              >
                                {siteTemplateId !== null &&
                                  siteTemplateId !== 6 && (
                                    <ArchivePeriodDropdown
                                      choosenPeriod={this.state.choosenPeriod}
                                      onChangeDropDown={
                                        this.handlePeriodDropDown
                                      }
                                      onChangeCheckBox={this.handleCheckBox}
                                      isLongTermConfirmed={
                                        this.state.isLongTermConfirmed
                                      }
                                    />
                                  )}
                              </ModalDialog>
                            )}
                            <ModalDialog
                              title={"Delete Site"}
                              text={
                                this.state.site.siteTemplate.id === 6 ? (
                                  <DeleteReason
                                    onSend={(reason) => {
                                      this.deleteSite(false, reason, true);
                                      this.setState({
                                        showDeleteReasonForm: false,
                                      });
                                    }}
                                  />
                                ) : (
                                  <div>
                                    You are going to delete this{" "}
                                    {this.state.isMsTeams ? "team" : "site"}. It
                                    will be deleted permanently. Are you sure
                                    you want to delete this{" "}
                                    {this.state.isMsTeams ? "team" : "site"}?
                                  </div>
                                )
                              }
                              displayConfirmButton={
                                this.state.site.siteTemplate.id !== 6
                              }
                              buttonName={`Delete ${
                                this.state.isMsTeams ? "Team" : "Site"
                              }`}
                              actionConfirmed={() => {
                                if (this.state.site.siteTemplate.id === 6) {
                                  this.setState({ showDeleteReasonForm: true });
                                } else {
                                  this.deleteSite(true);
                                }
                              }}
                            />
                          </div>
                        )}
                      </div>
                    ))}
                </div>
              </SecuredComponent>
            </div>
            <Separator styles={{ root: { margin: "10px 0" } }} />
            <div className="edit-panel">
              {this.state.isSaving && (
                <Spinner style={{ float: "left" }} size={SpinnerSize.medium} />
              )}
              <div style={{ marginTop: "10px" }}>
                {this.isRequestBlocked() && (
                  <MessageBar
                    dismissButtonAriaLabel="Close"
                    truncated={true}
                    messageBarType={MessageBarType.error}
                  >
                    Your change request can not be processed. Please contact
                    Support to fill in your Line Manager in organization
                    structure.
                  </MessageBar>
                )}
                {this.state.error && (
                  <MessageBar
                    dismissButtonAriaLabel="Close"
                    truncated={true}
                    messageBarType={MessageBarType.error}
                  >
                    We can not proceed your change request.
                  </MessageBar>
                )}
                {this.state.messageVisible && (
                  <MessageBar
                    dismissButtonAriaLabel="Close"
                    truncated={true}
                    messageBarType={MessageBarType.success}
                  >
                    Your change request has been received.
                  </MessageBar>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );

    return (
      <div>
        {siteTitle}
        <Pivot>
          <PivotItem headerText="Details">{editor}</PivotItem>
          {this.props.currentUser.role === "Administrator" && (
            <PivotItem headerText="Tasks">
              <SiteTasks site={this.state.site} />
            </PivotItem>
          )}
        </Pivot>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userId: state.user.currentUser.id,
  currentUser: state.user.currentUser,
});

const quotaAreaSites = {
  // position:'absolute',
  // left:'50%',
  // top: '114px',
  // height:'60px',
  float: "left",
  marginTop: "10px",
};

const quotaAreaTeams = {
  // position:'absolute',
  // left:'50%',
  // top: '184px',
  // height:'60px',
  float: "left",
  marginTop: "10px",
};

const teamsOwnerStyle = {
  width: "100%",
  marginTop: "10px",
};

const sitesOwnerStyle = {
  width: "38%",
  marginTop: "10px",
  float: "left",
  marginRight: "70px",
};
export default connect(mapStateToProps, null)(SiteEditor);



// WEBPACK FOOTER //
// ./src/components/EditSite/SiteEditor.js